var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHyperledgerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f3134",
    transform: "matrix(3.0313136 0 0 3.0313136 -30.313124 -58.939421)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.25472
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.015136 39.163556a.099402.099402 0 0 1 -.08092-.04177l-5.915983-8.377917a.09925171.09925171 0 0 1 -.0091-.09876l4.284801-9.321244a.09883142.09883142 0 0 1 .08091-.05726l10.200523-.943468a.09443495.09443495 0 0 1 .09004.0415l5.915998 8.377779a.09925935.09925935 0 0 1 .0091.09876l-4.284663 9.321523a.09938416.09938416 0 0 1 -.08092.05726l-10.200671.943328c-.003.000254-.0061.000254-.0091.000254zm-5.802016-8.487467 5.84988 8.284417 10.086699-.932816 4.236809-9.217512-5.84988-8.284414-10.086559.932818z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.979587 39.142257-1.63727-8.524262-.008-9.319033 7.976934 2.347946 8.27169 5.145844-6.143391 5.460796zm-1.545978-17.710787.0069 9.177121 1.610158 8.378195 8.331168-4.813193 6.036195-5.367014-8.153427-5.071988z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.442188,
    cy: 23.740612,
    r: 0.297065
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.442212 24.353576a.61295605.61295605 0 1 1 .612347-.613025.61348077.61348077 0 0 1 -.612347.613025zm0-.63073-.0184.0177a.01818957.01818957 0 0 0 .0184.01783z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.42532,
    cy: 34.198711,
    r: 0.297065
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.425282 34.811797a.61302737.61302737 0 1 1 .612472-.613014.61336615.61336615 0 0 1 -.612472.613014zm0-.63073-.01826.0177a.01803928.01803928 0 0 0 .01826.0177z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.087811,
    cy: 39.064545,
    r: 0.297065
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.087751 39.677559a.61302482.61302482 0 1 1 .612472-.613025.61336615.61336615 0 0 1 -.612472.613025zm0-.630731-.01825.0177a.01803928.01803928 0 0 0 .01825.0177z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.383887,
    cy: 30.707779,
    r: 0.297065
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.383951 31.320651a.61288727.61288727 0 1 1 .612335-.612747.61341964.61341964 0 0 1 -.612335.612747zm0-.63073-.0184.01798a.01825325.01825325 0 0 0 .0184.0177z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500488,
    cy: 28.814528,
    r: 0.297065
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.500483 29.427365a.61288727.61288727 0 1 1 .612472-.612748.61341964.61341964 0 0 1 -.612472.612748zm0-.630728-.01826.01798a.01803928.01803928 0 0 0 .01826.0177z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.383887,
    cy: 21.365255,
    r: 0.297065
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.383951 21.978242a.61295605.61295605 0 1 1 .612335-.613025.61348077.61348077 0 0 1 -.612335.613025zm0-.630731-.01841.01771a.01818957.01818957 0 0 0 .0184.01783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.215807 38.220228a.09762914.09762914 0 0 1 -.03306-.0055l-7.777625-2.745616-8.354538-4.696174a.09893076.09893076 0 0 1 -.0184-.15934l6.285729-5.759837 8.218857-4.518847a.09845189.09845189 0 0 1 .08839-.0036.09959558.09959558 0 0 1 .05602.06847l1.841426 8.095198-.207753 9.628453a.09939945.09939945 0 0 1 -.04274.07939.09840604.09840604 0 0 1 -.05631.01742zm-15.94889-7.55299 8.219819 4.622032 7.632945 2.693052.207199-9.467589-1.809893-7.942908-8.084408 4.44181z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.457649 34.236117-.04053-.01383-10.081857-3.504978.0325-.02822 8.09077-6.99543zm-10.025008-3.53762 9.960274 3.462921-1.967005-10.373978z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.373732 35.56148-2.119722-10.786727 10.365837 3.706232zm-1.858023-10.482698 1.986937 10.110905 7.729346-6.636777z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.97651 25.672207h.198297v4.085128h-.198297z",
    transform: "matrix(.87183309 -.48980309 .48980309 .87183309 0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m36.016 143.71.656.42-9.228 14.482-.656-.419z",
    transform: "matrix(.25472016 0 0 .25472016 9.180716 -1.283736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-26.614811 28.433397h.198111v4.085434h-.198111z",
    strokeWidth: 0.25472,
    transform: "matrix(.0728591 -.99734224 .99734224 .0728591 0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperledgerIcon);
export default __webpack_public_path__ + "static/media/hyperledger_icon.6a63acee86f9e3881873aade8cc6b8ad.svg";
export { ForwardRef as ReactComponent };